export default __webpack_public_path__ + "static/8-d6c633e35c990df5b81b5b3e41efb6d9.png";